import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import request from "../../Apis/request";
// import { BaseURL, uniqueToken, GpsBaseURL, Role }  from "../../Baseurls/DataApis";
import { BaseURL, uniqueToken, Role } from "../../api/DataApis";
import axios from "axios";
import Select from "react-select";
import "./User.css";

function Add() {
  document.title = "RFID | Assign";
  let navigate = useNavigate();

  const [Name, setName] = useState("");
  const [selectedStatusType, setSelectedStatusType] = useState("");
  const [Mobile, setMobile] = useState("");
  const [Email, setEmail] = useState([]);
  const [VehicleNumber, setVehicleNumber] = useState("");
  const [selectedParent, setselectedParent] = useState([]);
  const [userType, setUserType] = useState("");
 
  const [Address, setAddress] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [selectdStation, setselectedstation] = useState("");
  const [StationData, setStationData] = useState([]);
  const [SerialNumberList, setSerialNumberList] = useState([]); 
  const [loading, setLoading] = useState(false);
  // const [VendorAmount, setVendorAmount] = useState("");
 
  const [loadings, setLoadings] = useState(false);
  
  // const [bcorporateName, setbcorporateName] = useState("");
  // const [DistrictName, setDistrictName] = useState("");
  const [SerialNumber, setSerialNumber] = useState("");
  // const [bcAgentID, setbcAgentID] = useState("");
  const [loader, setloader] = useState(false);
  const [otpRequested, setOtpRequested] = useState(false);
  const [otp, setOtp] = useState("");
  const [restAllinputfields, setrestAllinputfields] = useState(false);
  const [vendorEditData, setVendorEditData] = useState({});
  const [Limit, setLimit] = useState("50");
  const [couponCode, setCouponCode] = useState("");
 
 
  const handleSerialNumber = (e) => {
    setSerialNumber(e.target.value);
  };

  const handleCoupnCode = (e) => {
    setCouponCode(e.target.value);
  };


    const handleBack = () => {
      navigate(0); // reloads the current page
    };
    



  const handleCountryChange = (selectedOption) => {
    // If no option is selected, reset selected country and state
    if (!selectedOption) {
      setSelectedCountry("");
      setSelectedState("");
    } else {
      // Update selectedCountry with the chosen option
      setSelectedCountry({ _id: selectedOption._id, id: selectedOption.value });
      setSelectedState(""); // Reset state when a new country is selected
    }
  };

  const handleStateChange = (selectedOption) => {
    if (selectedOption) {
      // Set the selected state if an option is chosen
      setSelectedState({ _id: selectedOption._id, id: selectedOption.value });
    } else {
      // Clear the selected state if no option is selected (cleared)
      setSelectedState("");
    }
  };

  const handleCityChange = (selectedOption) => {
    setSelectedCity(selectedOption ? selectedOption.value : "");
  };
  
  const FetchStationsData = async () => {
      setLoading(true);
      const url = `${BaseURL}/station/station/listing`;
  
      try {
        const res = await axios({
          url: url,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        if (res && res.data.data) {
          setStationData(res.data.data);
          
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
  };
  
  useEffect(() => {
    FetchStationsData(); // Pass current page and search query to the fetch function
  }, []);
  
  const fetchSearailNumber = async () => {
    setLoading(true);
    const url = `${BaseURL}/rfid/rfid-list`;

    try {
      const res = await axios({
        url: url,
        method: "GET",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      if (res && res.data.data) {
        setSerialNumberList(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSearailNumber(); // Pass current page and search query to the fetch function
  }, []);

  const countryOptions = countries.map((country) => ({
    value: country.id,
    label: country.name,
    _id: country._id,
  }));

  const stateOptions = states.map((state) => ({
    value: state.id,
    label: state.name,
    _id: state._id,
  }));

  const cityOptions = cities.map((city) => ({
    value: city._id,
    label: city.name,
  }));

  // Populate form fields with existing data on load

  // Handlers for form fields
  const handleName = (e) => setName(e.target.value);
  const handleFileChange = (e) => setSelectedFile(e.target.files[0]);
  const handleAddressChange = (e) => setAddress(e.target.value);
  const handleMobileChange = (e) => setMobile(e.target.value);
  const handleUserTypeChange = (e) => setUserType(e.target.value);
  const handleStatusType = (e) => setSelectedStatusType(e.target.value);

  const handleEmailChange = (e) => setEmail(e.target.value);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(`${BaseURL}/settings/countries`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        setCountries(response.data.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);

  useEffect(() => {
    if (selectedCountry.id) {
      const fetchStates = async () => {
        try {
          const response = await axios.get(
            `${BaseURL}/settings/states/${selectedCountry.id}`,
            {
              headers: {
                Authorization: `Bearer ${uniqueToken}`,
              },
            }
          );
          setStates(response.data.data.data);
          setCities([]);
        } catch (error) {
          console.error("Error fetching states:", error);
        }
      };

      fetchStates();
    }
  }, [selectedCountry.id]);
  console.log("selectedState.id", selectedState.id);

  const fetchCities = async () => {
    if (selectedState.id) {
      try {
        const response = await axios.get(
          `${BaseURL}/settings/cities/${selectedState.id}`,
          {
            headers: {
              Authorization: `Bearer ${uniqueToken}`,
            },
          }
        );
        console.log("Cities API Response:", response.data);
        if (response.data && response.data.data) {
          setCities(response.data.data.data);
        } else {
          console.warn("No cities data found in response:", response);
          setCities([]); // Clear the cities if response is empty
        }
      } catch (error) {
        console.error("Error fetching cities:", error);
        setCities([]); // Clear the cities in case of error
      }
    }
  };
  useEffect(() => {
    fetchCities(); // Ensure this function is called when selectedState.id changes
  }, [selectedState.id]);

  // Function to handle the update request
  const AddUser = async () => {
    // Show loader before API call
    Swal.fire({
      title: "Adding User...",
      text: "Please wait",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  
    //console.log("SerialNumber----", SerialNumber);
    // Create a new FormData object
    let formData = new FormData();
    formData.append("name", Name);
    formData.append("address", Address);
    formData.append("mobile", Mobile);
    formData.append("email", Email);
    if(couponCode){
      formData.append("coupon_code", couponCode);
    }
    if( SerialNumber?.serial_number ) {
      formData.append("serial_number", SerialNumber?.serial_number);
    }
    formData.append("limit", Limit);
    if(VehicleNumber) {
      formData.append("vehicle_number", VehicleNumber);
    }
    if (selectdStation) {
      formData.append("station_id", selectdStation);
    }

    if (selectedCountry?._id) {
      formData.append("countryId", selectedCountry._id);
    }

    if (selectedState?._id) {
      formData.append("stateId", selectedState._id);
    }

    if (selectedCity) {
      formData.append("cityId", selectedCity);
    }
  
   
   
    if(userType) {
      formData.append("userType", userType);
    }
  

    try {
      // Make the API request
      let response = await axios.put(`${BaseURL}/vendor/edit/${vendorEditData?._id}`, formData, {
        headers: {
          Authorization: `Bearer ${uniqueToken}`,
          // 'Content-Type' is automatically set by axios when using FormData
        },
      });

      // Hide the loader
      Swal.close();

      // Handle the response
      if (response.data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response?.data?.message,
          showConfirmButton: false,
          timer: 1500,
        });
         navigate(0);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Failed to update station. Status: ${response.data.statusCode}`,
        });
      }
    } catch (error) {
      // Hide the loader
      Swal.close();

      console.error("Error in AddUser:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "An unexpected error occurred.",
      });
    }
  };

  const handleUserRegister = async (e) => {
    e.preventDefault();

    if (!Mobile) {
      alert("Please Enter 10 diigt Mobile Number");
      return;
    }
    // Show loader before API call
    Swal.fire({
      title: "Adding User...",
      text: "Please wait",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      // Make the API request
      const response = await axios.post(
        `${BaseURL}/vendor/register`,
        { mobile: Mobile }, // ✅ body should be passed as a plain object
        {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
            // Content-Type is automatically set when passing a JSON object
          },
        }
      );

      // Hide loader
      Swal.close();

      // Handle success
      if (response.data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Otp Sent successfully.",
          showConfirmButton: false,
          timer: 1500,
        });
        setOtpRequested(true);
        // navigate(`/usermanagement/users`);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Failed to register user. Status: ${response.data.statusCode}`,
        });
      }
    } catch (error) {
      // Hide loader
      Swal.close();

      console.error("Error in handleUserRegister:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "An unexpected error occurred.",
      });
    }
  };
  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    if (!otp) {
      Swal.fire("Please enter the OTP.");
      return;
    }

    Swal.fire({
      title: "Verifying OTP...",
      text: "Please wait",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const response = await axios.put(
        `${BaseURL}/vendor/otp-verify`,
        { mobile: Mobile, otp: otp },
        {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        }
      );

      Swal.close();

      if (response.data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "OTP Verified!",
          text: "User verified successfully.",
          showConfirmButton: false,
          timer: 1500,
        });
        setOtpRequested(false);
        setVendorEditData(response?.data?.user);
        setrestAllinputfields(true);
        setOtp("");
        // You can now redirect or enable next steps
      } else {
        Swal.fire({
          icon: "error",
          title: "Invalid OTP",
          text: response.data.message || "Please try again.",
        });
      }
    } catch (error) {
      Swal.close();
      console.error("Error verifying OTP:", error);
      Swal.fire({
        icon: "error",
        title: "Verification Failed",
        text: error.response?.data?.message || "An unexpected error occurred.",
      });
    }
  };

  useEffect(() => {
    if (vendorEditData) {
      // Set the input fields with the fetched user data
      setName(vendorEditData?.name || "");
      setMobile(vendorEditData?.mobile || "");
      setEmail(vendorEditData?.email || "");
       setVehicleNumber(vendorEditData?.vehicle_number || "");
      // setselectedParent(vendorEditData?.parent || "");
      setAddress(vendorEditData?.address || "");
      setUserType(vendorEditData?.userType || "");
      // setVehicleNumber(vendorEditData?.vehicle_number || "");
      // setUserType(vendorEditData?.userType);
      if (
        vendorEditData?.station_id &&
        Array.isArray(vendorEditData.station_id) &&
        vendorEditData.station_id.length > 0
      ) {
        setselectedstation(vendorEditData.station_id[0]);
      } else {
        console.error("station_id is undefined, not an array, or empty");
      }

      // Only set the country, state, and city once after fetching data
      if (!selectedCountry._id && vendorEditData?.countryId) {
        const country = countries.find(
          (c) => c._id === vendorEditData?.countryId[0]
        );
        if (country) {
          setSelectedCountry({ _id: country._id, id: country.id });
        }
      }

      if (!selectedState._id && vendorEditData?.stateId) {
        const state = states.find((s) => s._id === vendorEditData?.stateId[0]);
        if (state) {
          setSelectedState({ _id: state._id, id: state.id });
        }
      }

      if (!selectedCity && vendorEditData?.cityId) {
        const city = cities.find((c) => c._id === vendorEditData?.cityId[0]);
        if (city) {
          setSelectedCity(city._id);
        }
      }
    }
  }, [vendorEditData, countries, states, cities]);
  useEffect(() => {
    // setImageurl(vendorEditData?.imageURL || null);
  }, [vendorEditData]);


  const options = SerialNumberList?.map((serial) => ({
    value: serial,
    label: serial.serial_number,
  }));

  console.log("StationData---", StationData);
  console.log("stationEditData", vendorEditData);
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <h1 className="page-title"></h1>
              <div className="portlet light bordered">
                <div className="portlet-title row">
                  <div className="caption font-dark col-md-10">
                    <h4 className="caption-subject bold uppercase mx-3">
                      Add Details
                    </h4>
                  </div>
                  <div className="caption font-dark col-md-2">
                    <h5 className="caption-subject bold uppercase mx-3">
                      <button
                        className="btn btn-success"
                        onClick={handleBack}
                      >
                        Back
                      </button>
                    </h5>
                  </div>
                </div>
                <div className="portlet-body mx-3">
                  <hr />
                  <div className="row">
                    <div className="col-sm-12">
                      <form
                        className="form-horizontal"
                        encType="multipart/form-data"
                        role="form"
                        method="post"
                        style={{ marginTop: "-20px" }}
                      >
                        <div className="form-group">
                          <div className="row align-items-center">
                            <label
                              htmlFor="mobile"
                              className="col-sm-2 control-label"
                            >
                              Mobile
                            </label>
                            <div className="col-sm-6">
                              <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                id="mobile"
                                value={Mobile}
                                placeholder="Enter Mobile"
                                maxLength={10}
                                disabled={restAllinputfields}
                                onChange={(e) => {
                                  const val = e.target.value;
                                  if (/^\d*$/.test(val) && val.length <= 10) {
                                    handleMobileChange(e);
                                  }
                                }}
                              />

                              {!restAllinputfields && (
                                <div className="input-group-append">
                                  <button
                                    className="btn btn-primary"
                                    onClick={handleUserRegister}
                                  >
                                    Request OTP
                                  </button>
                                </div>
                              )}

                              </div>
                            </div>
                          </div>

                          {/* OTP Input Field + Submit Button on the same row */}
                          {otpRequested && (
                            <div className="row align-items-center mt-3">
                              <label
                                htmlFor="otp"
                                className="col-sm-2 control-label"
                              >
                                OTP
                              </label>
                              <div className="col-sm-6">
                                <div className="input-group">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="otp"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)}
                                    placeholder="Enter OTP"
                                  />
                                  <div className="input-group-append">
                                    <button
                                      className="btn btn-success"
                                      onClick={handleVerifyOtp}
                                    >
                                      Submit OTP
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                        {restAllinputfields && (
                          <>
                            <div className="form-group">
                              <div className="row">
                                <label
                                  htmlFor="name_id"
                                  className="col-sm-2 control-label"
                                >
                                  Name
                                </label>
                                <div className="col-sm-6">
                                  <input
                                    onChange={handleName}
                                    value={Name}
                                    className="form-control"
                                    id="name_id"
                                    name="station_name"
                                  />
                                </div>
                                <span className="col-sm-4 control-label"></span>
                              </div>
                            </div>

                            <div className="form-group">
                              <div className="row">
                                <label
                                  htmlFor="longitude_id"
                                  className="col-sm-2 control-label"
                                >
                                  Enter Email
                                </label>
                                <div className="col-sm-6">
                                  <input
                                    type="email"
                                    onChange={handleEmailChange}
                                    className="form-control"
                                    id="email"
                                    name="email"
                                    value={Email}
                                  />
                                </div>
                                <span className="col-sm-4 control-label"></span>
                              </div>
                            </div>
                            <div className="form-group">
                              <div className="row">
                                <label
                                  htmlFor="country_id"
                                  className="col-sm-2 control-label"
                                >
                                  Select Country
                                </label>
                                <div className="col-sm-6">
                                  <Select
                                    options={countryOptions}
                                    onChange={handleCountryChange}
                                    value={
                                      countryOptions.find(
                                        (option) =>
                                          option.value === selectedCountry.id
                                      ) || null
                                    }
                                    placeholder="Country"
                                    isClearable
                                    styles={{
                                      control: (base) => ({
                                        ...base,
                                        height: "38px",
                                        width: "100%", // Make width responsive
                                        boxShadow: "none",
                                        minWidth: "0", // Ensures it can shrink below 165px if needed
                                        flex: 1, // Allow select to grow and shrink
                                      }),
                                    }}
                                  />
                                </div>
                                <span className="col-sm-4 control-label"></span>
                              </div>
                            </div>

                            <div className="form-group">
                              <div className="row">
                                <label
                                  htmlFor="state_id"
                                  className="col-sm-2 control-label"
                                >
                                  Select State
                                </label>
                                <div className="col-sm-6">
                                  <Select
                                    options={stateOptions}
                                    value={
                                      stateOptions.find(
                                        (option) =>
                                          option.value === selectedState.id
                                      ) || null
                                    }
                                    onChange={(selectedOption) => {
                                      if (selectedOption) {
                                        setSelectedState({
                                          _id: selectedOption._id,
                                          id: selectedOption.value,
                                        });
                                      } else {
                                        setSelectedState(""); // Clear selection if option is cleared
                                      }
                                    }}
                                    placeholder="State"
                                    isClearable
                                    styles={{
                                      control: (base) => ({
                                        ...base,
                                        height: "38px",
                                        width: "100%", // Make width responsive
                                        minWidth: "150px",
                                        flex: 1,
                                      }),
                                    }}
                                  />
                                </div>
                                <span className="col-sm-4 control-label"></span>
                              </div>
                            </div>

                            <div className="form-group">
                              <div className="row">
                                <label
                                  htmlFor="city_id"
                                  className="col-sm-2 control-label"
                                >
                                  Select City
                                </label>
                                <div className="col-sm-6">
                                  <Select
                                    value={
                                      cityOptions.find(
                                        (option) =>
                                          option.value === selectedCity
                                      ) || null
                                    }
                                    onChange={handleCityChange}
                                    options={cityOptions}
                                    placeholder="City"
                                    isClearable
                                    styles={{
                                      control: (base) => ({
                                        ...base,
                                        height: "38px",
                                        width: "100%", // Make width responsive
                                        boxShadow: "none",
                                        minWidth: "150px", // Ensures it can shrink below 150px if needed
                                        flex: 1, // Allow select to grow and shrink
                                      }),
                                    }}
                                  />
                                </div>
                                <span className="col-sm-4 control-label"></span>
                              </div>
                            </div>

                            <div className="form-group">
                              <div className="row">
                                <label
                                  htmlFor="address_id"
                                  className="col-sm-2 control-label"
                                >
                                  Address
                                </label>
                                <div className="col-sm-6">
                                  <textarea
                                    onChange={handleAddressChange}
                                    value={Address}
                                    className="form-control"
                                    id="address_id"
                                    name="address"
                                  />
                                </div>
                                <span className="col-sm-4 control-label"></span>
                              </div>
                            </div>

                            <div className="form-group">
                              <div className="row">
                                <label
                                  htmlFor="address_id"
                                  className="col-sm-2 control-label"
                                >
                              Vehicle Number
                                </label>
                                <div className="col-sm-6">
                                  <input
                                    onChange={(e)=> setVehicleNumber(e.target.value)}
                                    value={VehicleNumber}
                                    className="form-control"
                                    id="address_id"
                                    name="address"
                                  />
                                </div>
                                <span className="col-sm-4 control-label"></span>
                              </div>
                            </div>

                            <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Station Name
                            </label>
                            <div className="col-sm-6">
                              <select
                              type="station_id"
                                onChange={(e)=> setselectedstation(e.target.value)}
                                className="form-control"
                                id="station_id"
                                name="station_id"
                                value={selectdStation}
                              
                              >
                                <option value="">Select Station</option>
                                {StationData?.map((item) => {
                                  return (
                                    <option
                                      key={item?._id}
                                      value={item?._id}
                                    >
                                      {item?.station_name}
                                    </option>
                                  );
                                })}
                                </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>


                            <div className="form-group">
                              <div className="row">
                                <label
                                  htmlFor="address_id"
                                  className="col-sm-2 control-label"
                                >
                                  Serial Number
                                </label>
                                {/* <div className="col-sm-6">
                                  <input
                                    onChange={handleSerialNumber}
                                    value={SerialNumber}
                                    className="form-control"
                                    id="address_id"
                                    name="address"
                                  />
                                </div> */}
                                <div className="col-sm-6">
                                  <Select
                                    options={options}
                                    onChange={(selectedOption) => setSerialNumber(selectedOption?.value)}
                                    value={options.find((option) => option.value === SerialNumber)}
                                    placeholder="Select Serial Number"
                                    isSearchable
                                  />
                                </div>
                                <span className="col-sm-4 control-label"></span>
                              </div>
                            </div>
                            <div className="form-group">
                              <div className="row">
                                <label
                                  htmlFor="address_id"
                                  className="col-sm-2 control-label"
                                >
                                Limit
                                </label>
                                <div className="col-sm-6">
                                  <input
                                    onChange={(e)=>setLimit(e.target.value)}
                                    value={Limit}
                                    className="form-control"
                                    id="address_id"
                                    name="address"
                                    disabled
                                  />
                                </div>
                                <span className="col-sm-4 control-label"></span>
                              </div>
                            </div>
                            <div className="form-group">
                              <div className="row">
                                <label
                                  htmlFor="address_id"
                                  className="col-sm-2 control-label"
                                >
                                   Coupon Code
                                </label>
                                <div className="col-sm-6">
                                  <input
                                    onChange={handleCoupnCode}
                                    value={couponCode}
                                    className="form-control"
                                    id="coupon_code_id"
                                    name="couponCode"
                                  />
                                </div>
                                <span className="col-sm-4 control-label"></span>
                              </div>
                            </div>
                          </>
                        )}
 {restAllinputfields && (
  <>
                        <div className="form-group">
                          <div className="col-sm-offset-2 col-sm-8 add-class">
                            <input
                              type="button"
                              className="btn btn-success"
                              onClick={AddUser}
                              value="Update Details"
                            />
                          </div>
                        </div>
                        </>
 )}
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Add;
